import { GetStaticProps, NextPage } from "next";

import { getVenuesContactInfo } from "~/api/venues/getVenuesContactInfo";
import AboutFooter from "~/components/about/footer";
import AboutIntroduction from "~/components/about/introduction";
import SEO from "~/components/SEO";
import AboutContact from "~/components/ui/contact";
import { LocationEnum } from "~/types/location/locationEnums.types";
import { VenueContactInfo } from "~/types/venue/venue.types";
import { createVenuesContactInfoObject } from "~/utils/functions/locations.functions";

type Props = {
  contactInfo: Record<LocationEnum, VenueContactInfo>;
};

export const getStaticProps: GetStaticProps<Props, never> = async () => {
  const venuesContactInfo = await getVenuesContactInfo();
  const contactInfo = createVenuesContactInfoObject(venuesContactInfo, [
    LocationEnum.HORS_LES_MURS,
  ]);
  return {
    props: { contactInfo },
  };
};

const AboutPage: NextPage<Props> = ({ contactInfo }) => {
  return (
    <>
      <SEO
        title="Silencio - À propos de"
        description="Ses lieux confidentiels, dédiés aux arts et à la fête, font de lui un rendez-vous incontournable qui réunit les artistes et les créatifs. "
        nofollow={false}
        noindex={false}
      />
      <AboutIntroduction />
      {/* <AboutSpecialRequest /> */}
      <AboutContact contactInfo={contactInfo} />
      <AboutFooter />
    </>
  );
};

export default AboutPage;
